import styled from 'styled-components'

import { Link } from 'react-router-dom'

import { theme } from '../../../styles/theme'

interface IProps {
  isPhone?: boolean
}

export const Container = styled(Link)<IProps>`
  display: flex;
  align-items: center;
  gap: 6px;

  text-decoration: ${({ isPhone }) => (isPhone ? 'underline' : 'none')};
  font-size: ${theme.font.sizes.small};
  font-weight: ${theme.font.normal};
  color: ${theme.colors.lightGreen};

  svg {
    width: 16px;
    height: 16px;

    path {
      fill: ${theme.colors.lightGreen};
    }

    &[data-name='arrow-right'] {
      width: 10px;
      height: 10px;
    }
  }
`
